import styled from 'styled-components';

import { rem, mediaUp } from 'approot/shared/style';
import {
  grey1,
  grey6,
  grey7,
  grey8,
  grey9,
  purple7,
  coolGrey2,
  grey5,
} from 'approot/shared/styles/colours.style';
import {
  baseBoxShadowFocus,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import {
  fontSize16,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  spacing16,
  spacing20,
  spacing24,
} from 'approot/shared/styles/spacing.style';

type TabsStyledProps = {
  $fillWidth?: boolean;
};
export const TabsStyled = styled.div<TabsStyledProps>`
  display: flex;
  height: 100%;
  outline: 0;

  ${({ $fillWidth }) =>
    $fillWidth
      ? `
        & > button {
          flex: 1;
        }
    `
      : `
      gap: ${rem(spacing16)};
    `}
`;

type TabsTabProps = {
  $isActive?: boolean;
  $isFocussed: boolean;
};
export const TabsTabStyled = styled.button<TabsTabProps>`
  background-color: ${grey1};
  border: none;
  border-radius: ${rem(borderRadius8)};
  color: ${grey8};
  font-size: ${rem(fontSize16)};
  padding: ${rem(spacing16)} 0;
  position: relative;
  height: 100%;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  &:hover {
    color: ${grey7};
  }

  &:active {
    color: ${grey9};
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:active {
    color: ${grey6};
    cursor: not-allowed;
  }

  &:before {
    display: block;
    content: attr(data-title);
    font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }

  ${({ $isActive, $isFocussed }) =>
    $isActive &&
    `
      color: ${grey9};
      font-weight: ${fontWeightMedium};

      &:hover {
        color: ${grey9};
      }

      &:after {
        content: '';
        background-color: ${purple7};
        border-radius: ${rem(3)};
        bottom: -1px;
        height: ${rem(3)};
        left: 0;
        right: 0;
        position: absolute;
      }

      ${$isFocussed &&
        `
        color: ${grey9};
      `}

      &:disabled,
      &:disabled:hover,
      &:disabled:active {
        color: ${grey6};
        cursor: not-allowed;
      }
      &:disabled:after {
        background-color: ${grey6};
      } 
  `}

  ${({ $isFocussed }) =>
    $isFocussed &&
    `
    box-shadow: inset ${baseBoxShadowFocus};
    color: ${grey9};
    z-index: 1;
  `}
`;

export const TabsSkeletonStyled = styled.div`
  display: flex;
  height: ${rem(48)};
  margin-top: ${rem(spacing20)};
  justify-content: space-between;

  ${mediaUp.md`
    height: ${rem(50)};
    margin-right: ${rem(spacing24)};
    justify-content: inherit;
  `}
`;

export const TabsTabSkeletonStyled = styled.div`
  flex: 1;
  position: relative;
  padding: 0 ${rem(spacing16)};

  ${mediaUp.md`
    margin-right: ${rem(spacing24)};
    max-width: ${rem(80)};
    padding: 0;
  `}

  &:before {
    content: '';
    flex: 1;

    background-color: ${coolGrey2};
    border-radius: ${rem(borderRadius8)};
    display: block;
    height: ${rem(32)};
  }

  &:first-child:after {
    content: '';
    background-color: ${coolGrey2};
    border-radius: ${rem(3)};
    bottom: -1px;
    height: ${rem(4)};
    left: 0;
    right: 0;
    position: absolute;
  }
`;

export const TabsWrapper = styled.div`
  border-bottom: 1px solid ${grey5};
  height: ${rem(64)};
  flex-shrink: 0;
`;

export const TabsScrollable = styled.div`
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 ${rem(spacing16)};

  button {
    white-space: nowrap;
  }
`;
